/*
 * Copyright © 2018 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschützt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulässig. Dies gilt
 * insbesondere für Vervielfältigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht übergeben, ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 */

import {ChangeDetectionStrategy, Component, computed, effect, inject, ViewChild} from '@angular/core';
import {Observable} from 'rxjs';
import {MarkerService} from '../../core/marker.service';
import {PdfGeneratorService} from '../../printing/pdf/pdf-generator/pdf-generator.service';
import {NgProgressbar} from 'ngx-progressbar';

@Component({
    selector: 'elohn-toolbar-root',
    templateUrl: './toolbar-root.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ToolbarRootComponent {

    readonly pdfGeneratorService = inject(PdfGeneratorService);
    @ViewChild('progressbar') progressBar: NgProgressbar | undefined;
    readonly hasMarks$: Observable<boolean>;
    readonly completedCount = computed(() => this.pdfGeneratorService.completedCount() ?? 0);
    readonly queueSize = computed(() => this.pdfGeneratorService.queueSize() ?? 0);

    constructor(
        markerService: MarkerService,
    ) {
        this.hasMarks$ = markerService.hasMarks$();
        effect(() => {
            const completedCount = this.pdfGeneratorService.completedCount();
            const totalCount = this.pdfGeneratorService.queueSize();
            if (completedCount === undefined || totalCount === undefined) {
                return;
            }
            this.progressBar?.set(100 / totalCount * completedCount);
        }, {allowSignalWrites: true}); // unfortunately there's no other way of setting a value in the progress bar.
        effect(() => {
            const inProgress = this.pdfGeneratorService.inProgress();
            if (inProgress) {
                this.progressBar?.start();
            } else {
                this.progressBar?.complete();
            }
        }, {allowSignalWrites: true});
    }
}
